export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-10 sm:py-14 md:py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 lg:gap-12 mb-10 sm:mb-12 md:mb-14 lg:mb-16">
          {/* Brand Column */}
          <div className="col-span-1">
            <img 
              src="https://static.readdy.ai/image/839dec6a9613ad5b94c8c6c1844a10c6/3ee9a274e58c80cc0e503777418aeb7b.png" 
              alt="BestCall Restor" 
              className="h-9 sm:h-10 md:h-12 w-auto mb-4 sm:mb-5 md:mb-6"
            />
            <p className="text-xs sm:text-sm text-white/70 leading-relaxed mb-4 sm:mb-5 md:mb-6">
              Transforming houses into dream homes since 2022. Quality craftsmanship, exceptional service.
            </p>
            <div className="flex gap-3 sm:gap-4 md:gap-5">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-[#2563EB] hover:bg-[#2563EB] transition-all duration-300 cursor-pointer">
                <i className="ri-facebook-fill text-base sm:text-lg"></i>
              </a>
              <a href="https://www.instagram.com/bestcallrestor/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-[#2563EB] hover:bg-[#2563EB] transition-all duration-300 cursor-pointer">
                <i className="ri-instagram-line text-base sm:text-lg"></i>
              </a>
              <a href="https://houzz.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-[#2563EB] hover:bg-[#2563EB] transition-all duration-300 cursor-pointer">
                <i className="ri-home-smile-line text-base sm:text-lg"></i>
              </a>
              <a href="https://google.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-[#2563EB] hover:bg-[#2563EB] transition-all duration-300 cursor-pointer">
                <i className="ri-google-fill text-base sm:text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-sm sm:text-base font-bold mb-3 sm:mb-4 md:mb-6 uppercase tracking-wider">Services</h3>
            <ul className="space-y-2 sm:space-y-2.5 md:space-y-3">
              <li>
                <a href="#services" className="text-xs sm:text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Bathroom Remodels
                </a>
              </li>
              <li>
                <a href="#services" className="text-xs sm:text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Kitchen Remodels
                </a>
              </li>
              <li>
                <a href="#services" className="text-xs sm:text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Interior Painting
                </a>
              </li>
              <li>
                <a href="#services" className="text-xs sm:text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Exterior Painting
                </a>
              </li>
              <li>
                <a href="#services" className="text-xs sm:text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Flooring Installation
                </a>
              </li>
              <li>
                <a href="#services" className="text-xs sm:text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Drywall Work
                </a>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-sm sm:text-base font-bold mb-3 sm:mb-4 md:mb-6 uppercase tracking-wider">Company</h3>
            <ul className="space-y-2 sm:space-y-2.5 md:space-y-3">
              <li>
                <a href="#about" className="text-xs sm:text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-xs sm:text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-xs sm:text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#contact" className="text-xs sm:text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-sm sm:text-base font-bold mb-3 sm:mb-4 md:mb-6 uppercase tracking-wider">Contact</h3>
            <ul className="space-y-2.5 sm:space-y-3 md:space-y-4">
              <li className="flex items-start gap-2 sm:gap-3">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-sm sm:text-base text-white/70"></i>
                </div>
                <span className="text-xs sm:text-sm text-white/70">
                  801 Copenhagen Way<br />
                  Winter Garden, FL 34787
                </span>
              </li>
              <li className="flex items-center gap-2 sm:gap-3">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-sm sm:text-base text-white/70"></i>
                </div>
                <span className="text-xs sm:text-sm text-white/70">+1 (321) 947-6724</span>
              </li>
              <li className="flex items-center gap-2 sm:gap-3">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-sm sm:text-base text-white/70"></i>
                </div>
                <span className="text-xs sm:text-sm text-white/70">bestcallrestor@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-5 sm:pt-6 md:pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
          <p className="text-xs sm:text-sm text-white/60 text-center sm:text-left">
            © {new Date().getFullYear()} BestCall Restor. All rights reserved.
          </p>
          <div className="flex items-center gap-4 sm:gap-6">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs sm:text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}